import React from 'react';
import { AccordionWrapper } from '../styles';
import AccordionButton from './AccordionButton';
import AccordionContent from './AccordionContent';
import { useConsolidatedNavContext } from 'src/providers/ConsolidatedNavContextProvider';
import { CC_MODAL_TOOLBAR_ID } from 'src/commons/constants';

interface AccordionProps {
  id: string;
}

const Accordion: React.VFC<AccordionProps> = ({ id }) => {
  const { isQuickNavModalEnabled, activeCategoryId, selectedNavItemId } =
    useConsolidatedNavContext();
  const isActive = id === activeCategoryId;
  const cbSelected =
    !isQuickNavModalEnabled && selectedNavItemId === CC_MODAL_TOOLBAR_ID;

  return (
    <AccordionWrapper isActive={isActive}>
      <AccordionButton id={id} cbSelected={cbSelected} />
      <AccordionContent id={id} cbSelected={cbSelected} />
    </AccordionWrapper>
  );
};

export default Accordion;
